import React from "react";

export default ({ color = "#9EA0A5" }) => (
  <svg
    className="fill-current inline"
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M7,16 L9,16 L9,8 L7,8 L7,16 Z M11,16 L13,16 L13,8 L11,8 L11,16 Z M5,18 L15,18 L15,6 L5,6 L5,18 Z M7,4 L13,4 L13,2 L7,2 L7,4 Z M15,4 L15,0 L5,0 L5,4 L0,4 L0,6 L3,6 L3,20 L17,20 L17,6 L20,6 L20,4 L15,4 Z"
        id="delete-path-id"
      />
    </defs>
    <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
      <mask id="mask-delete-path-id" fill="white">
        <use xlinkHref="#delete-path-id" />
      </mask>
      <use fillOpacity={0} fill="#FFFFFF" xlinkHref="#delete-path-id" />
      <g mask="url(#mask-delete-path-id)" fill={color}>
        <g transform="translate(-1.000000, -1.000000)" id="Colour">
          <rect x={0} y={0} width={22} height={22} />
        </g>
      </g>
    </g>
  </svg>
);
